// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build
// @ts-nocheck
import { fullFormats as formats } from 'ajv-formats/dist/formats.js';
import { countCodePoints } from '#runtime/validation/index.ts';
export const validateDeleteUserRequestPayload = validate52;
const schema19 = {
  $ref: 'urn:cascade:contract#/$defs/DeleteUserRequestPayload',
};
const schema21 = {
  description:
    'Removes the membership. The person survives as a not_enrolled row if anything else knows them — their tags and HRIS data are not membership data.\n',
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
    },
    project_id: { type: 'string' },
  },
  required: ['project_id', 'email'],
};
const pattern3 = new RegExp(
  "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
  'u',
);
function validate54(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate54.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.project_id === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'project_id' },
        message: "must have required property '" + 'project_id' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.email === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'email' },
        message: "must have required property '" + 'email' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.email !== undefined) {
      let data0 = data.email;
      if (typeof data0 === 'string') {
        if (!pattern3.test(data0)) {
          const err2 = {
            instancePath: instancePath + '/email',
            schemaPath: '#/properties/email/pattern',
            keyword: 'pattern',
            params: {
              pattern:
                "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
            },
            message:
              'must match pattern "' +
              "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$" +
              '"',
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = {
          instancePath: instancePath + '/email',
          schemaPath: '#/properties/email/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
    if (data.project_id !== undefined) {
      if (typeof data.project_id !== 'string') {
        const err4 = {
          instancePath: instancePath + '/project_id',
          schemaPath: '#/properties/project_id/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate54.errors = vErrors;
  return errors === 0;
}
validate54.evaluated = {
  props: { email: true, project_id: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate52(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate52.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate54(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate54.errors : vErrors.concat(validate54.errors);
    errors = vErrors.length;
  }
  validate52.errors = vErrors;
  return errors === 0;
}
validate52.evaluated = {
  props: { email: true, project_id: true },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateGetProjectsWhereAdminRequestPayload = validate56;
const schema22 = {
  $ref: 'urn:cascade:contract#/$defs/GetProjectsWhereAdminRequestPayload',
};
const schema23 = { type: 'object', additionalProperties: false };
function validate57(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate57.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = {
        instancePath,
        schemaPath: '#/additionalProperties',
        keyword: 'additionalProperties',
        params: { additionalProperty: key0 },
        message: 'must NOT have additional properties',
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate57.errors = vErrors;
  return errors === 0;
}
validate57.evaluated = {
  props: true,
  dynamicProps: false,
  dynamicItems: false,
};
function validate56(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate56.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate57(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate57.errors : vErrors.concat(validate57.errors);
    errors = vErrors.length;
  }
  validate56.errors = vErrors;
  return errors === 0;
}
validate56.evaluated = {
  props: true,
  dynamicProps: false,
  dynamicItems: false,
};
export const validateGetUserDataRequestPayload = validate59;
const schema24 = {
  $ref: 'urn:cascade:contract#/$defs/GetUserDataRequestPayload',
};
const schema25 = { type: 'object', additionalProperties: false };
function validate60(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate60.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = {
        instancePath,
        schemaPath: '#/additionalProperties',
        keyword: 'additionalProperties',
        params: { additionalProperty: key0 },
        message: 'must NOT have additional properties',
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate60.errors = vErrors;
  return errors === 0;
}
validate60.evaluated = {
  props: true,
  dynamicProps: false,
  dynamicItems: false,
};
function validate59(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate59.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate60(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
    errors = vErrors.length;
  }
  validate59.errors = vErrors;
  return errors === 0;
}
validate59.evaluated = {
  props: true,
  dynamicProps: false,
  dynamicItems: false,
};
export const validateGetUserProjectsRequestPayload = validate62;
const schema26 = {
  $ref: 'urn:cascade:contract#/$defs/GetUserProjectsRequestPayload',
};
const schema27 = { type: 'object', additionalProperties: false };
function validate63(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate63.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    for (const key0 in data) {
      const err0 = {
        instancePath,
        schemaPath: '#/additionalProperties',
        keyword: 'additionalProperties',
        params: { additionalProperty: key0 },
        message: 'must NOT have additional properties',
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
  } else {
    const err1 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err1];
    } else {
      vErrors.push(err1);
    }
    errors++;
  }
  validate63.errors = vErrors;
  return errors === 0;
}
validate63.evaluated = {
  props: true,
  dynamicProps: false,
  dynamicItems: false,
};
function validate62(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate62.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate63(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate63.errors : vErrors.concat(validate63.errors);
    errors = vErrors.length;
  }
  validate62.errors = vErrors;
  return errors === 0;
}
validate62.evaluated = {
  props: true,
  dynamicProps: false,
  dynamicItems: false,
};
export const validateListUsersRequestPayload = validate65;
const schema28 = {
  $ref: 'urn:cascade:contract#/$defs/ListUsersRequestPayload',
};
const schema29 = {
  description:
    'The project directory: search, filter, sort and paginate every person in a project, enrolled or not.\n',
  type: 'object',
  properties: {
    filters: { $ref: 'urn:cascade:contract#/$defs/ListUsersFilters' },
    page: { type: 'integer', default: 1, minimum: 1 },
    page_size: { type: 'integer', default: 25, maximum: 100, minimum: 1 },
    project_id: { type: 'string', minLength: 1 },
    query_text: {
      description: 'Anchored prefix match on name and email.',
      type: 'string',
      maxLength: 200,
    },
    sort: {
      description:
        'Ordered — the first entry is the primary key. Defaults to primary_role descending then name ascending.\n',
      type: 'array',
      items: { $ref: 'urn:cascade:contract#/$defs/ListUsersSortItem' },
    },
  },
  required: ['project_id'],
};
const schema30 = {
  type: 'object',
  properties: {
    primary_role: {
      description:
        'Badge semantics, not "holds this role" — filtering user excludes admins who also hold user.\n',
      type: 'array',
      items: {
        enum: [
          'customer_success',
          'admin',
          'helpdesk_admin',
          'dependent',
          'user',
        ],
        type: 'string',
      },
    },
    status: {
      type: 'array',
      items: {
        enum: ['active', 'pending_invite', 'not_enrolled'],
        type: 'string',
      },
    },
    tags: {
      description:
        'Map of tag keys to arrays of tag value-KEYS (never display labels). AND across keys, OR within a key. An empty array means the tag is unset, so it must survive serialization.\n',
      type: 'object',
      additionalProperties: { items: { type: 'string' }, type: 'array' },
    },
  },
};
function validate67(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate67.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.primary_role !== undefined) {
      let data0 = data.primary_role;
      if (Array.isArray(data0)) {
        const len0 = data0.length;
        for (let i0 = 0; i0 < len0; i0++) {
          let data1 = data0[i0];
          if (typeof data1 !== 'string') {
            const err0 = {
              instancePath: instancePath + '/primary_role/' + i0,
              schemaPath: '#/properties/primary_role/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err0];
            } else {
              vErrors.push(err0);
            }
            errors++;
          }
          if (!(
            data1 === 'customer_success' ||
            data1 === 'admin' ||
            data1 === 'helpdesk_admin' ||
            data1 === 'dependent' ||
            data1 === 'user'
          )) {
            const err1 = {
              instancePath: instancePath + '/primary_role/' + i0,
              schemaPath: '#/properties/primary_role/items/enum',
              keyword: 'enum',
              params: {
                allowedValues: schema30.properties.primary_role.items.enum,
              },
              message: 'must be equal to one of the allowed values',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      } else {
        const err2 = {
          instancePath: instancePath + '/primary_role',
          schemaPath: '#/properties/primary_role/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.status !== undefined) {
      let data2 = data.status;
      if (Array.isArray(data2)) {
        const len1 = data2.length;
        for (let i1 = 0; i1 < len1; i1++) {
          let data3 = data2[i1];
          if (typeof data3 !== 'string') {
            const err3 = {
              instancePath: instancePath + '/status/' + i1,
              schemaPath: '#/properties/status/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err3];
            } else {
              vErrors.push(err3);
            }
            errors++;
          }
          if (!(
            data3 === 'active' ||
            data3 === 'pending_invite' ||
            data3 === 'not_enrolled'
          )) {
            const err4 = {
              instancePath: instancePath + '/status/' + i1,
              schemaPath: '#/properties/status/items/enum',
              keyword: 'enum',
              params: { allowedValues: schema30.properties.status.items.enum },
              message: 'must be equal to one of the allowed values',
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
        }
      } else {
        const err5 = {
          instancePath: instancePath + '/status',
          schemaPath: '#/properties/status/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    if (data.tags !== undefined) {
      let data4 = data.tags;
      if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
        for (const key0 in data4) {
          let data5 = data4[key0];
          if (Array.isArray(data5)) {
            const len2 = data5.length;
            for (let i2 = 0; i2 < len2; i2++) {
              if (typeof data5[i2] !== 'string') {
                const err6 = {
                  instancePath:
                    instancePath +
                    '/tags/' +
                    key0.replace(/~/g, '~0').replace(/\//g, '~1') +
                    '/' +
                    i2,
                  schemaPath:
                    '#/properties/tags/additionalProperties/items/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err6];
                } else {
                  vErrors.push(err6);
                }
                errors++;
              }
            }
          } else {
            const err7 = {
              instancePath:
                instancePath +
                '/tags/' +
                key0.replace(/~/g, '~0').replace(/\//g, '~1'),
              schemaPath: '#/properties/tags/additionalProperties/type',
              keyword: 'type',
              params: { type: 'array' },
              message: 'must be array',
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
          }
        }
      } else {
        const err8 = {
          instancePath: instancePath + '/tags',
          schemaPath: '#/properties/tags/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
  } else {
    const err9 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err9];
    } else {
      vErrors.push(err9);
    }
    errors++;
  }
  validate67.errors = vErrors;
  return errors === 0;
}
validate67.evaluated = {
  props: { primary_role: true, status: true, tags: true },
  dynamicProps: false,
  dynamicItems: false,
};
const schema31 = {
  type: 'object',
  properties: {
    direction: { type: 'string', default: 'asc', enum: ['asc', 'desc'] },
    field: {
      type: 'string',
      enum: ['name', 'email', 'invited_at', 'primary_role', 'status'],
    },
  },
  required: ['field'],
};
function validate69(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate69.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.field === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'field' },
        message: "must have required property '" + 'field' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.direction !== undefined) {
      let data0 = data.direction;
      if (typeof data0 !== 'string') {
        const err1 = {
          instancePath: instancePath + '/direction',
          schemaPath: '#/properties/direction/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (!(data0 === 'asc' || data0 === 'desc')) {
        const err2 = {
          instancePath: instancePath + '/direction',
          schemaPath: '#/properties/direction/enum',
          keyword: 'enum',
          params: { allowedValues: schema31.properties.direction.enum },
          message: 'must be equal to one of the allowed values',
        };
        if (vErrors === null) {
          vErrors = [err2];
        } else {
          vErrors.push(err2);
        }
        errors++;
      }
    }
    if (data.field !== undefined) {
      let data1 = data.field;
      if (typeof data1 !== 'string') {
        const err3 = {
          instancePath: instancePath + '/field',
          schemaPath: '#/properties/field/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if (!(
        data1 === 'name' ||
        data1 === 'email' ||
        data1 === 'invited_at' ||
        data1 === 'primary_role' ||
        data1 === 'status'
      )) {
        const err4 = {
          instancePath: instancePath + '/field',
          schemaPath: '#/properties/field/enum',
          keyword: 'enum',
          params: { allowedValues: schema31.properties.field.enum },
          message: 'must be equal to one of the allowed values',
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
  } else {
    const err5 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err5];
    } else {
      vErrors.push(err5);
    }
    errors++;
  }
  validate69.errors = vErrors;
  return errors === 0;
}
validate69.evaluated = {
  props: { direction: true, field: true },
  dynamicProps: false,
  dynamicItems: false,
};
const func1 = countCodePoints;
function validate66(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate66.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.project_id === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'project_id' },
        message: "must have required property '" + 'project_id' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.filters !== undefined) {
      if (
        !validate67(data.filters, {
          instancePath: instancePath + '/filters',
          parentData: data,
          parentDataProperty: 'filters',
          rootData,
          dynamicAnchors,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate67.errors
            : vErrors.concat(validate67.errors);
        errors = vErrors.length;
      }
    }
    if (data.page !== undefined) {
      let data1 = data.page;
      if (!(
        typeof data1 == 'number' &&
        !(data1 % 1) &&
        !isNaN(data1) &&
        isFinite(data1)
      )) {
        const err1 = {
          instancePath: instancePath + '/page',
          schemaPath: '#/properties/page/type',
          keyword: 'type',
          params: { type: 'integer' },
          message: 'must be integer',
        };
        if (vErrors === null) {
          vErrors = [err1];
        } else {
          vErrors.push(err1);
        }
        errors++;
      }
      if (typeof data1 == 'number' && isFinite(data1)) {
        if (data1 < 1 || isNaN(data1)) {
          const err2 = {
            instancePath: instancePath + '/page',
            schemaPath: '#/properties/page/minimum',
            keyword: 'minimum',
            params: { comparison: '>=', limit: 1 },
            message: 'must be >= 1',
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      }
    }
    if (data.page_size !== undefined) {
      let data2 = data.page_size;
      if (!(
        typeof data2 == 'number' &&
        !(data2 % 1) &&
        !isNaN(data2) &&
        isFinite(data2)
      )) {
        const err3 = {
          instancePath: instancePath + '/page_size',
          schemaPath: '#/properties/page_size/type',
          keyword: 'type',
          params: { type: 'integer' },
          message: 'must be integer',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
      if (typeof data2 == 'number' && isFinite(data2)) {
        if (data2 > 100 || isNaN(data2)) {
          const err4 = {
            instancePath: instancePath + '/page_size',
            schemaPath: '#/properties/page_size/maximum',
            keyword: 'maximum',
            params: { comparison: '<=', limit: 100 },
            message: 'must be <= 100',
          };
          if (vErrors === null) {
            vErrors = [err4];
          } else {
            vErrors.push(err4);
          }
          errors++;
        }
        if (data2 < 1 || isNaN(data2)) {
          const err5 = {
            instancePath: instancePath + '/page_size',
            schemaPath: '#/properties/page_size/minimum',
            keyword: 'minimum',
            params: { comparison: '>=', limit: 1 },
            message: 'must be >= 1',
          };
          if (vErrors === null) {
            vErrors = [err5];
          } else {
            vErrors.push(err5);
          }
          errors++;
        }
      }
    }
    if (data.project_id !== undefined) {
      let data3 = data.project_id;
      if (typeof data3 === 'string') {
        if (func1(data3) < 1) {
          const err6 = {
            instancePath: instancePath + '/project_id',
            schemaPath: '#/properties/project_id/minLength',
            keyword: 'minLength',
            params: { limit: 1 },
            message: 'must NOT have fewer than 1 characters',
          };
          if (vErrors === null) {
            vErrors = [err6];
          } else {
            vErrors.push(err6);
          }
          errors++;
        }
      } else {
        const err7 = {
          instancePath: instancePath + '/project_id',
          schemaPath: '#/properties/project_id/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.query_text !== undefined) {
      let data4 = data.query_text;
      if (typeof data4 === 'string') {
        if (func1(data4) > 200) {
          const err8 = {
            instancePath: instancePath + '/query_text',
            schemaPath: '#/properties/query_text/maxLength',
            keyword: 'maxLength',
            params: { limit: 200 },
            message: 'must NOT have more than 200 characters',
          };
          if (vErrors === null) {
            vErrors = [err8];
          } else {
            vErrors.push(err8);
          }
          errors++;
        }
      } else {
        const err9 = {
          instancePath: instancePath + '/query_text',
          schemaPath: '#/properties/query_text/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
    }
    if (data.sort !== undefined) {
      let data5 = data.sort;
      if (Array.isArray(data5)) {
        const len0 = data5.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (
            !validate69(data5[i0], {
              instancePath: instancePath + '/sort/' + i0,
              parentData: data5,
              parentDataProperty: i0,
              rootData,
              dynamicAnchors,
            })
          ) {
            vErrors =
              vErrors === null
                ? validate69.errors
                : vErrors.concat(validate69.errors);
            errors = vErrors.length;
          }
        }
      } else {
        const err10 = {
          instancePath: instancePath + '/sort',
          schemaPath: '#/properties/sort/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate66.errors = vErrors;
  return errors === 0;
}
validate66.evaluated = {
  props: {
    filters: true,
    page: true,
    page_size: true,
    project_id: true,
    query_text: true,
    sort: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
function validate65(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate65.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate66(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
    errors = vErrors.length;
  }
  validate65.errors = vErrors;
  return errors === 0;
}
validate65.evaluated = {
  props: {
    filters: true,
    page: true,
    page_size: true,
    project_id: true,
    query_text: true,
    sort: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateSaveUserRequestPayload = validate72;
const schema32 = { $ref: 'urn:cascade:contract#/$defs/SaveUserRequestPayload' };
const schema33 = {
  description:
    'Adds a person to a project or changes their role. Keyed on email, which is the only handle that works before someone has an account. The role set is replaced, not extended — the directory badges one role, so granting additively would leave the badge where it was.\n',
  type: 'object',
  properties: {
    email: {
      type: 'string',
      pattern: "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
    },
    helpdesk_ids: {
      description:
        'Required and non-empty when role is helpdesk_admin. For every other role it must be absent or empty — an admin is project-wide, so a scope on one would imply a limit nothing enforces.\n',
      type: 'array',
      items: { type: 'string' },
    },
    name: {
      description:
        'Only used before the person has an account; theirs wins after.',
      type: 'string',
    },
    project_id: { type: 'string' },
    role: {
      type: 'string',
      enum: ['customer_success', 'admin', 'helpdesk_admin', 'user'],
    },
  },
  required: ['project_id', 'email', 'role'],
};
function validate73(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate73.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.project_id === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'project_id' },
        message: "must have required property '" + 'project_id' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.email === undefined) {
      const err1 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'email' },
        message: "must have required property '" + 'email' + "'",
      };
      if (vErrors === null) {
        vErrors = [err1];
      } else {
        vErrors.push(err1);
      }
      errors++;
    }
    if (data.role === undefined) {
      const err2 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'role' },
        message: "must have required property '" + 'role' + "'",
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
    if (data.email !== undefined) {
      let data0 = data.email;
      if (typeof data0 === 'string') {
        if (!pattern3.test(data0)) {
          const err3 = {
            instancePath: instancePath + '/email',
            schemaPath: '#/properties/email/pattern',
            keyword: 'pattern',
            params: {
              pattern:
                "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
            },
            message:
              'must match pattern "' +
              "^[a-zA-Z0-9._%+'`\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$" +
              '"',
          };
          if (vErrors === null) {
            vErrors = [err3];
          } else {
            vErrors.push(err3);
          }
          errors++;
        }
      } else {
        const err4 = {
          instancePath: instancePath + '/email',
          schemaPath: '#/properties/email/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err4];
        } else {
          vErrors.push(err4);
        }
        errors++;
      }
    }
    if (data.helpdesk_ids !== undefined) {
      let data1 = data.helpdesk_ids;
      if (Array.isArray(data1)) {
        const len0 = data1.length;
        for (let i0 = 0; i0 < len0; i0++) {
          if (typeof data1[i0] !== 'string') {
            const err5 = {
              instancePath: instancePath + '/helpdesk_ids/' + i0,
              schemaPath: '#/properties/helpdesk_ids/items/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            };
            if (vErrors === null) {
              vErrors = [err5];
            } else {
              vErrors.push(err5);
            }
            errors++;
          }
        }
      } else {
        const err6 = {
          instancePath: instancePath + '/helpdesk_ids',
          schemaPath: '#/properties/helpdesk_ids/type',
          keyword: 'type',
          params: { type: 'array' },
          message: 'must be array',
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      }
    }
    if (data.name !== undefined) {
      if (typeof data.name !== 'string') {
        const err7 = {
          instancePath: instancePath + '/name',
          schemaPath: '#/properties/name/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err7];
        } else {
          vErrors.push(err7);
        }
        errors++;
      }
    }
    if (data.project_id !== undefined) {
      if (typeof data.project_id !== 'string') {
        const err8 = {
          instancePath: instancePath + '/project_id',
          schemaPath: '#/properties/project_id/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err8];
        } else {
          vErrors.push(err8);
        }
        errors++;
      }
    }
    if (data.role !== undefined) {
      let data5 = data.role;
      if (typeof data5 !== 'string') {
        const err9 = {
          instancePath: instancePath + '/role',
          schemaPath: '#/properties/role/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err9];
        } else {
          vErrors.push(err9);
        }
        errors++;
      }
      if (!(
        data5 === 'customer_success' ||
        data5 === 'admin' ||
        data5 === 'helpdesk_admin' ||
        data5 === 'user'
      )) {
        const err10 = {
          instancePath: instancePath + '/role',
          schemaPath: '#/properties/role/enum',
          keyword: 'enum',
          params: { allowedValues: schema33.properties.role.enum },
          message: 'must be equal to one of the allowed values',
        };
        if (vErrors === null) {
          vErrors = [err10];
        } else {
          vErrors.push(err10);
        }
        errors++;
      }
    }
  } else {
    const err11 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err11];
    } else {
      vErrors.push(err11);
    }
    errors++;
  }
  validate73.errors = vErrors;
  return errors === 0;
}
validate73.evaluated = {
  props: {
    email: true,
    helpdesk_ids: true,
    name: true,
    project_id: true,
    role: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
function validate72(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate72.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate73(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate73.errors : vErrors.concat(validate73.errors);
    errors = vErrors.length;
  }
  validate72.errors = vErrors;
  return errors === 0;
}
validate72.evaluated = {
  props: {
    email: true,
    helpdesk_ids: true,
    name: true,
    project_id: true,
    role: true,
  },
  dynamicProps: false,
  dynamicItems: false,
};
export const validateSetUserDisplayNameRequestPayload = validate75;
const schema34 = {
  $ref: 'urn:cascade:contract#/$defs/SetUserDisplayNameRequestPayload',
};
const schema35 = {
  type: 'object',
  properties: { displayName: { type: 'string', maxLength: 100, minLength: 2 } },
  required: ['displayName'],
};
function validate76(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate76.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    if (data.displayName === undefined) {
      const err0 = {
        instancePath,
        schemaPath: '#/required',
        keyword: 'required',
        params: { missingProperty: 'displayName' },
        message: "must have required property '" + 'displayName' + "'",
      };
      if (vErrors === null) {
        vErrors = [err0];
      } else {
        vErrors.push(err0);
      }
      errors++;
    }
    if (data.displayName !== undefined) {
      let data0 = data.displayName;
      if (typeof data0 === 'string') {
        if (func1(data0) > 100) {
          const err1 = {
            instancePath: instancePath + '/displayName',
            schemaPath: '#/properties/displayName/maxLength',
            keyword: 'maxLength',
            params: { limit: 100 },
            message: 'must NOT have more than 100 characters',
          };
          if (vErrors === null) {
            vErrors = [err1];
          } else {
            vErrors.push(err1);
          }
          errors++;
        }
        if (func1(data0) < 2) {
          const err2 = {
            instancePath: instancePath + '/displayName',
            schemaPath: '#/properties/displayName/minLength',
            keyword: 'minLength',
            params: { limit: 2 },
            message: 'must NOT have fewer than 2 characters',
          };
          if (vErrors === null) {
            vErrors = [err2];
          } else {
            vErrors.push(err2);
          }
          errors++;
        }
      } else {
        const err3 = {
          instancePath: instancePath + '/displayName',
          schemaPath: '#/properties/displayName/type',
          keyword: 'type',
          params: { type: 'string' },
          message: 'must be string',
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      }
    }
  } else {
    const err4 = {
      instancePath,
      schemaPath: '#/type',
      keyword: 'type',
      params: { type: 'object' },
      message: 'must be object',
    };
    if (vErrors === null) {
      vErrors = [err4];
    } else {
      vErrors.push(err4);
    }
    errors++;
  }
  validate76.errors = vErrors;
  return errors === 0;
}
validate76.evaluated = {
  props: { displayName: true },
  dynamicProps: false,
  dynamicItems: false,
};
function validate75(
  data,
  {
    instancePath = '',
    parentData,
    parentDataProperty,
    rootData = data,
    dynamicAnchors = {},
  } = {},
) {
  let vErrors = null;
  let errors = 0;
  const evaluated0 = validate75.evaluated;
  if (evaluated0.dynamicProps) {
    evaluated0.props = undefined;
  }
  if (evaluated0.dynamicItems) {
    evaluated0.items = undefined;
  }
  if (
    !validate76(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
      dynamicAnchors,
    })
  ) {
    vErrors =
      vErrors === null ? validate76.errors : vErrors.concat(validate76.errors);
    errors = vErrors.length;
  }
  validate75.errors = vErrors;
  return errors === 0;
}
validate75.evaluated = {
  props: { displayName: true },
  dynamicProps: false,
  dynamicItems: false,
};
